import React from 'react'
import * as S from './style'

const ButtonRelation = ({ title, onClick, isDamage=false, disabled=false, }) => {
  return (
    <>
      <S.Button onClick={onClick} isDamage={isDamage} disabled={disabled} data-testid='button-relation-test-id'>
        <S.Text>{title}</S.Text>
      </S.Button>
    </>
  )
}

export { ButtonRelation }
